// extracted by mini-css-extract-plugin
export default {"wrapper":"UU-z","availablePromoMessagesLabel":"VU-z","promoMessageList":"WU-z","promoMessage":"XU-z","appliedPromoMessage":"YU-z","promoMessageAmount":"ZU-z"};